import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { MyStoryPage } from './pages/MyStoryPage';
import { ServicesPage } from './pages/ServicesPage';
import { ResultsPage } from './pages/ResultsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  useEffect(() => {
    const onLocationChange = () => {
      setCurrentPath(window.location.hash);
      // Scroll to top on route change
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', onLocationChange);
    return () => window.removeEventListener('hashchange', onLocationChange);
  }, []);
  // Simple router
  if (currentPath === '#/my-story') {
    return <MyStoryPage data-id="element-0" data-mp="28tmfp53igeya" />;
  }
  if (currentPath === '#/services') {
    return <ServicesPage data-id="element-1" data-mp="23vcjcr61v8b3" />;
  }
  if (currentPath === '#/results') {
    return <ResultsPage data-id="element-2" data-mp="23v2rey1g2r2r" />;
  }
  if (currentPath === '#/resources') {
    return <ResourcesPage data-id="element-3" data-mp="3iiwdijzxza14" />;
  }
  if (currentPath === '#/contact' || currentPath === '#/contact/book') {
    return <ContactPage data-id="element-4" data-mp="3mkho1yp07c85" />;
  }
  // Default route
  return <HomePage data-id="element-5" data-mp="3mj6jvxrnc2gi" />;
}